<template>
  <v-container>
    <v-col>
      <div class="display-3">{{ $t('NotFound').title }}</div>
      <div class="grey--text lighten-5 mt-4">{{ $t('NotFound').text1 }}</div>
      <div class="mt-3">{{ $t('NotFound').text2 }}</div>
      <div v-if="menu">
        <i18n path="NotFound.text3" tag="p" class="mt-5">
          <template #page>
            <span>
              {{ $t(menu).content.title }}
            </span>
          </template>
        </i18n>
      </div>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound',
  props: {
    menu: {
      type: String,
    },
  },
}
</script>
